import React from 'react';
import Link from '../../router/Link';
import { classIf } from '../../data/utils';
import AllSportsIcon from '../../svg/AllSportsIcon';

export default function SidebarLink(props) {
    return (
        <Link className={(active) => "c_14" + classIf(active, 'active')} href={props.href} exact>
            <AllSportsIcon className="c_14_1" height="16px" width="16px" />
            <span className="c_14_2">{props.text}</span>
            <div className="c_14_3">
                {props.info &&
                    <span className="c_14_3_1">{props.info}</span>
                }
            </div>
        </Link>
    );
}
